// Design tokens for the Sigma Enterprises editorial site.
//
// Text colours here are measured against the three surfaces they actually sit
// on — bg #F6F1E9, white #FFFFFF and panel #F1EADC — and every one of them now
// clears the WCAG AA 4.5:1 minimum for body-size text. The ratios are recorded
// beside each value so a future tweak can be checked rather than guessed at;
// the panel is the darkest surface and is therefore always the binding case.

export const colors = {
  bg: "#F6F1E9",
  ink: "#2B2722",
  ink2: "#3a352d",
  ink3: "#4a443b",
  // Was #9A6A41: 4.14:1 on bg and 3.89:1 on panel, so the mono eyebrows and
  // every inline link set in it failed AA on the two surfaces they appear on
  // most. Darkened just far enough to clear it on all three while keeping the
  // same hue and chroma — side by side the change reads as the same brown.
  // bg 5.10:1 · white 5.73:1 · panel 4.79:1
  brown: "#8A5C35",
  gold: "#C9A96A",
  border: "#E4D9C8",
  borderSoft: "#EFE7D6",
  // bg 4.96:1 · white 5.57:1 · panel 4.66:1
  muted: "#6F675B",
  // Was #8A8175: 3.41:1 on bg. Used for breadcrumbs, spec-sheet labels and
  // card meta — all small text, all on bg or white, none on panel, which is
  // why it is allowed to stay a step lighter than `muted`. No lighter value
  // exists that clears 4.5:1 on panel, so if this is ever used there it has
  // to become `muted`. bg 4.67:1 · white 5.25:1
  muted2: "#736B5F",
  // `muted3` (#A79E8D) is gone. Its only remaining use was the footer bottom
  // bar, which sits on panel — its worst case, at 2.22:1. Nothing lighter than
  // `muted` passes on that surface, so the footer simply uses `muted` and a
  // third grey step is no longer something this palette can express.
  panel: "#F1EADC",
  white: "#FFFFFF",
  inputBg: "#FBF8F1",
  inputBorder: "#D9CDB8",
  // Form-error palette. Contact.jsx and ProductEnquiryModal.jsx both used to
  // hardcode this trio at each error banner; centralised so the two can't
  // drift, and so a future field-level error state (form.jsx) draws from the
  // same tokens. white 7.61:1 · inputBg 7.18:1 — both clear AA at body size
  // with headroom, which matters here since this text is the non-colour cue
  // for the error, not a decoration.
  danger: "#8C3A2B",
  dangerBg: "#FBEFEA",
  dangerBorder: "#EBD3C8",
};

export const fonts = {
  serif: "'Newsreader', serif",
  sans: "'Libre Franklin', system-ui, sans-serif",
  mono: "'IBM Plex Mono', monospace",
};

// Diagonal "photo placeholder" fill. `tight` uses a smaller stripe.
export const stripe = (tight = false) =>
  tight
    ? "repeating-linear-gradient(135deg,#EFE7D6 0 14px,#F3EDE1 14px 28px)"
    : "repeating-linear-gradient(135deg,#EFE7D6 0 16px,#F3EDE1 16px 32px)";

// Shared eyebrow / mono-label style.
export const eyebrow = {
  fontFamily: fonts.mono,
  fontSize: "12px",
  letterSpacing: "0.16em",
  textTransform: "uppercase",
  color: colors.brown,
};
